module.exports = __webpack_public_path__ + "img/Header2Kopf.eef8b244.jpg";